import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { STATUS } from 'utils/constants'
import { GET, POST } from 'rest/request'
import * as urls from 'rest/urls'

export const initialFilters = {
  attributes: {},
  size: {}
}

const initialState = {
  place: {
    id: '',
    status: STATUS.idle,
    data: {},
    colors: {}
  },
  filters: {
    types: {},
    status: STATUS.idle,
    data: initialFilters,
  },
  templates: {
    status: STATUS.idle,
    types: {},
    data: {}
  }
}

export const getPlaceFilters = createAsyncThunk('place/getFilters', async () => {
  return await GET(urls.mapfilters)
})

export const getPlaceDetails = createAsyncThunk('place/getPlaceDetails', async (placeId) => {
  return await POST(`${urls.locations}/${placeId}`)
})

export const placeSlice = createSlice({
  name: 'place',
  initialState,
  reducers: {
    addFilters: (state, action) => {
      const { filters, checkTheCorrectness = true } = action.payload
      if (!filters) {
        state.filters.data = initialFilters
      } else {
        if (checkTheCorrectness) {
          // if (filters?.attributes?.hash && (!filters?.attributes?.categoryId || !filters?.attributes?.warehouseTypeId)) {
          //   delete filters.attributes.hash
          // }
          // if (filters?.attributes?.warehouseTypeId && !filters?.attributes?.categoryId) {
          //   delete filters.attributes.warehouseTypeId
          // }
          if (filters?.attributes?.hash && !filters?.attributes?.warehouseTypeId) {
            delete filters.attributes.hash
          }
        }
        state.filters.data = filters
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlaceFilters.fulfilled, (state, action) => {
        const { filters, templates } = action.payload

        state.filters = {
          data: state.filters.data,
          status: STATUS.succeed,
          types: filters
        }
        state.templates = {
          status: STATUS.succeed,
          types: templates
        }
      })
      .addCase(getPlaceFilters.rejected, (state, _) => {
        state.filters.status = STATUS.failed
        state.templates.status = STATUS.failed
      })
      .addCase(getPlaceDetails.pending, (state, action) => {
        if (state.place.id && state.place.id !== action.meta.arg) {
          state.place = {
            id: '',
            status: STATUS.idle,
            data: {},
            colors: {}
          }
        }
      })
      .addCase(getPlaceDetails.fulfilled, (state, action) => {
        const colors = action.payload?.warehouseTypes?.data?.reduce((r, e) => {
          if (e.options) {
            const values = e.options.reduce((rr, ee) => {
              rr = { ...rr, [ee.hash]: ee.color }
              return rr
            }, {})
            r = { ...r, ...values }
          }
          return r
        }, {})

        state.place = {
          id: action.meta.arg,
          status: STATUS.succeed,
          data: action.payload.places?.[0],
          colors
        }
      })
      .addCase(getPlaceDetails.rejected, (state, _) => {
        state.place.status = STATUS.failed
      })
  }
})

export const { addFilters } = placeSlice.actions

export const selectPlaceId = state => state.place.place.id
export const selectPlaceData = state => state.place.place.data
export const selectPlaceStatus = state => state.place.place.status
export const selectPlaceColors = state => state.place.place.colors
export const selectPlaceFilters = state => state.place.filters.data
export const selectPlaceTemplatesData = state => state.place.templates.data

export default placeSlice.reducer
